import React from 'react';
import ProductsCarousel from '../../../../product-carousel/products-carousel';
import Link from 'atomic/link';
import { SimilarProductInterface } from 'modules/product/interfaces/similar-product.interface';

const ProductWidgetSimilarProduct: React.FC<{
    products?: {
        count: number;
        items: SimilarProductInterface[];
    } | null;
    isMobile: boolean;
    categoryUrl: string;
    productId: number;
    isSlideIndicator?: boolean;
}> = ({ isMobile, categoryUrl, products, isSlideIndicator = false }) => {
    if (!products) {
        return null;
    }

    return (
        <ProductsCarousel
            headerTitle="Produkty polecane dla Ciebie"
            products={products}
            isMobile={isMobile}
            isSlideIndicator={isSlideIndicator}
        >
            <Link href={categoryUrl}
                type="button"
                size="lg"
                color="transparent-secondary"
                weight="500"
            >
                Sprawdź wszystkie
            </Link>
        </ProductsCarousel>
    );
};

export default ProductWidgetSimilarProduct;
